import { components } from "react-select";

const ReactSelectOption = ({
  getStyles,
  data,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}: any) => {
  const props = {
    ...innerProps
  };

  if (data.hidden) {
    return <></>;
  }

  return (
    <components.Option
      className="react-select__custom-component d-flex align-items-center py-1"
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >

      {!data.name ? 
        <input readOnly className="react-select__checkbox form-check-input m-0 p-0 me-2 bg-secondary border border-light" style={{fontSize: '1rem'}} type="checkbox" checked={isSelected} disabled={isDisabled} /> :
        <input readOnly className="react-select__checkbox form-check-input m-0 p-0 me-2 bg-secondary border border-light" style={{fontSize: '1rem'}} type="radio" checked={isSelected} disabled={isDisabled} />
      }
      
      {children}
    </components.Option>
  );
};

export default ReactSelectOption;